import * as api from '../api/alertConfiguration.api';
import { CriteriaListItem } from '../types/AlertConfiguration';

export const getAlertCriteria = async (alertId: number): Promise<CriteriaListItem[]> => {
  const { alertCriteriaList } = await api.getAlertCriteria({ alertId });
  return alertCriteriaList.map((item) => ({
    ...item,
    sourceOwnerId: String(item.sourceOwnerId),
    competitorOwnerId: item.competitorOwnerId.split(','),
  }));
};

export const priceCollectedTime = async (sourceOwnerId: string): Promise<string> => {
  const { priceCollectedTime } = await api.priceCollectedTime(sourceOwnerId);
  return priceCollectedTime.priceCollectedTimestamp;
};
